export type ImageFileBase64 = {
  base64: string;
  mimeType: 'image/svg+xml' | 'image/png';
};

export const base64ToFile = (base64Data: string, filename: string, mimeType: string) => {
  const byteString = atob(base64Data);
  const uint8Array = Uint8Array.from(byteString, (char) => char.charCodeAt(0));
  return new File([uint8Array], filename, { type: mimeType });
};

export const getExtension = (mimeType: string): string => {
  switch (mimeType) {
    case 'image/svg+xml':
      return '.svg';
    case 'image/png':
      return '.png';
    default:
      return '';
  }
};
